export default __webpack_public_path__ + "static/media/user-solid.75003372.svg";